<template>
  <div ref="listElements" class="listElements" :style="{ height: ht }">
    <v-list class="py-0">
      <v-list-item v-for="(item, i) in visibleListItems" :key="i" @click="$emit('rowClick', item)">
        <v-badge v-if="item.unread && !item.unconfirmed" :color="theme.unreadBadgeColor" overlap dot offset-x="24" offset-y="20">
          <v-list-item-avatar class="ml-0">
            <v-icon class="grey lighten-1" dark>{{ item.icon }}</v-icon>
          </v-list-item-avatar>
        </v-badge>
        <v-badge v-else-if="item.unconfirmed" :color="theme.toAcknowledgeBadgeColor" overlap dot offset-x="24" offset-y="20">
          <v-list-item-avatar class="ml-0">
            <v-icon class="grey lighten-1" dark>{{ item.icon }}</v-icon>
          </v-list-item-avatar>
        </v-badge>
        <v-list-item-avatar v-else class="ml-0">
          <v-icon class="grey lighten-1" dark>{{ item.icon }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="item.name" class="text-truncate"></v-list-item-title>
          <v-list-item-subtitle>
            <span v-for="(tagId, i) in item.tags" :key="i">
              <v-chip v-if="tagsById[tagId]" class="mr-1 px-2" small>{{ tagsById[tagId].name }}</v-chip>
            </span></v-list-item-subtitle
          >
        </v-list-item-content>
        <v-list-item-action>
          <v-icon v-if="item.type == 'FOLDER'">mdi-chevron-right</v-icon>
          <v-icon v-else-if="item.favorite" :color="theme.elements.activeColor">
            {{ mx_icons.favoriteIconActive }}
          </v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-pagination
      v-if="listItems.length > perPage"
      @input="paginationClick"
      v-model="page"
      :length="numPages"
      :total-visible="7"
      class="py-2"
    ></v-pagination>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'MediaModuleListLayout',
  mixins: [common],
  props: {
    currentChildren: Object,
    listItems: Array,
  },
  data() {
    return {
      page: 1,
      perPage: 20,
      ht: '100%',
    };
  },
  methods: {
    paginationClick() {
      window.setTimeout(() => {
        this.handleResize();
      }, 500);
    },
    handleResize() {
      if (this.$refs.listElements) {
        this.ht = window.innerHeight - this.$refs.listElements.getBoundingClientRect().y - 54 + 'px';
      }
    },
  },
  computed: {
    ...mapState('media', ['tagsById']),
    numPages() {
      return Math.ceil(this.listItems.length / this.perPage);
    },
    visibleListItems() {
      return this.listItems.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
  },
  watch: {
    currentChildren(to, from) {
      window.setTimeout(() => {
        this.handleResize();
      }, 250);
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    window.setTimeout(() => {
      this.handleResize();
    }, 500);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.listElements {
  overflow-y: auto;
}
.v-list {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.v-list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.v-list-item__title {
  max-width: 100%;
}
</style>
